module.exports = __webpack_public_path__ + "img/newbg_pc.6db0ca50.png";